import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
const PURCHASE_URL = 'https://tucambiohoy.online/cart/42988674941041:1';
export function HeroSection() {
  const handleBuy = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-[#fdfbf7] pt-10 pb-12 px-6" data-id="element-116">
      <div className="max-w-3xl mx-auto text-center" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-118">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#1e3a5f] leading-tight mb-4 tracking-tight" data-id="element-119">
            Cada día que pasa, la pantalla gana más poder que tú.
          </h1>
          <p className="text-lg md:text-xl text-[#2d3748] mb-3 max-w-2xl mx-auto leading-relaxed" data-id="element-120">
            Si hoy no recuperas el control, mañana será más difícil.
          </p>
          <p className="text-lg md:text-xl text-[#2d3748] mb-3 max-w-2xl mx-auto leading-relaxed" data-id="element-121">
            Tu hijo no necesita más gritos. Necesita una{' '}
            <strong data-id="element-122">estrategia clara</strong> que funcione sin romper la
            conexión.
          </p>
          <p className="text-lg md:text-xl text-[#1e3a5f] mb-8 max-w-2xl mx-auto leading-relaxed font-bold" data-id="element-123">
            Recupera tu autoridad con límites firmes y efectivos — y vuelve a
            sentirte en control.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="mb-8" data-id="element-124">
          <img src="https://cdn.magicpatterns.com/uploads/mUsGVABZGC5kwXtwyiqgiK/Bundle_de_libro_Pantallas_bajo_Control.png" alt="Bundle completo Pantallas Bajo Control" className="mx-auto w-full rounded-xl shadow-2xl" data-id="element-125" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-lg mx-auto" data-id="element-126">
          <Button fullWidth size="lg" onClick={handleBuy} className="text-sm md:text-base shadow-xl shadow-red-200 py-4 px-6" data-id="element-127">
            SÍ, QUIERO RECUPERAR EL CONTROL HOY
          </Button>
          <p className="text-center text-xs text-gray-500 mt-3" data-id="element-128">
            Acceso inmediato • 100% Digital • Garantía 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}